import Axios from "axios";

import { SubscriptionInterval } from "@intelligems/ig-types";

export const approveBilling = async (subscriptionId: string) => {
  const { data } = await Axios.request({
    baseURL: import.meta.env.VITE_BASE_URL,
    url: "/billing",
    params: { subscriptionId: subscriptionId },
    method: "get",
    headers: { authorization: sessionStorage.getItem("token") as string },
  });
  if (data && data.billingUrl) {
    window.location.href = data.billingUrl;
  }
};

export const billingSentence = (subscriptionDetails: {
  intervalCount: number;
  interval: SubscriptionInterval;
  totalPrice: number;
}) => {
  if (subscriptionDetails.intervalCount === 1) {
    return `$${subscriptionDetails.totalPrice.toFixed(2)} ${
      subscriptionDetails.interval
    }`;
  }
  return `$${subscriptionDetails.totalPrice.toFixed(2)} every ${
    subscriptionDetails.intervalCount
  } ${subscriptionDetails.interval === "monthly" ? "months" : "years"}`;
};
